module.exports = __webpack_public_path__ + "img/inge-v6-char-2.ca0a6ef0.png";